import Cart from './Cart'
import './Cart.css'

export default Cart



// WEBPACK FOOTER //
// ./src/features/Cart/containers/Cart/index.js